import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { setToken, setName, setUserPhone } from "@/utils/auth";
Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "login",
        component: () => import("../views/login/login.vue"),
        meta: {
            title: "实验室申报登录"
        }
    },
    {
        path: "/stop",
        name: "stop",
        component: () => import("../views/stop.vue"),
        meta: {
            title: "申报截止"
        }
    },
    // {
    //     path: "/",
    //     redirect: "/index"
    // },
    {
        path: "/login-register",
        name: "login-register",
        component: () => import("../views/login/login-register.vue"),
        meta: {
            title: "忘记密码"
        }
    },
    {
        path: "/auth-login",
        name: "auth-login",
        component: () => import("../views/login/auth-login.vue"),
        meta: {
            title: "统一身份认证登录"
        }
    },
    {
        path: "/declare",
        name: "declare",
        meta: {
            title: "申报认定管理"
        },
        component: () => import("../views/declare/index.vue"),
        children: [
            // {
            //     path: "list", //申报认定
            //     component: () => import("../views/declare/list.vue"),
            //     meta: {
            //         title: "申报认定"
            //     }
            // },
            {
                path: "add", //申报认定
                component: () => import("../views/declare/add.vue"),
                meta: {
                    title: "申报认定管理"
                }
            }
            // {
            //     path: "submit",
            //     component: () => import("../views/declare/submit.vue"),
            //     meta: {
            //         title: "申报认定管理"
            //     }
            // }
        ]
    },
    {
        path: "/research",
        name: "research",
        meta: {
            title: "布局方案填报"
        },
        component: () => import("../views/research/index.vue"),
        children: [
            // {
            //     path: "list", //科研任务布局方案
            //     component: () => import("../views/research/list.vue"),
            //     meta: {
            //         title: "科研任务布局方案"
            //     }
            // },
            {
                path: "add", //科研任务布局方案
                component: () => import("../views/research/add.vue"),
                meta: {
                    title: "布局方案填报"
                }
            }
            // {
            //     path: "submit",
            //     component: () => import("../views/research/submit.vue"),
            //     meta: {
            //         title: "布局方案填报"
            //     }
            // }
        ]
        //research
    },
    {
        path: "/task",
        name: "task",
        meta: {
            title: "任务签订填报"
        },
        component: () => import("../views/task/index.vue"),
        children: [
            // {
            //     path: "list", //申报认定
            //     component: () => import("../views/declare/list.vue"),
            //     meta: {
            //         title: "申报认定"
            //     }
            // },
            {
                path: "add", //申报认定
                component: () => import("../views/task/add.vue"),
                meta: {
                    title: "任务签订填报"
                }
            },
            {
                path: "submit",
                component: () => import("../views/task/components/submit.vue"),
                meta: {
                    title: "任务签订填报"
                }
            }
        ]
    },
    {
        path: "/annual",
        name: "annual",
        meta: {
            title: "年度总结填报"
        },
        component: () => import("../views/annual/index.vue"),
        children: [
            // {
            //     path: "list", //科研任务布局方案
            //     component: () => import("../views/research/list.vue"),
            //     meta: {
            //         title: "科研任务布局方案"
            //     }
            // },
            {
                path: "add", //科研任务布局方案
                component: () => import("../views/annual/add.vue"),
                meta: {
                    title: "年度总结填报"
                }
            }
            // {
            //     path: "submit",
            //     component: () => import("../views/research/submit.vue"),
            //     meta: {
            //         title: "布局方案填报"
            //     }
            // }
        ]
    },
    {
        path: "/", //根路径
        name: "home",
        meta: {
            title: "中关村高新技术企业bei认定管理"
        },
        component: () => import("../views/index.vue"), //主布局组件
        children: [
            {
                path: "index", //首页
                name: "index",
                component: () => import("../views/index/index.vue"),
                meta: {
                    title: "创新券首页"
                }
            },
            {
                path: "declare/list", //申报认定
                component: () => import("../views/declare/list.vue"),
                meta: {
                    title: "申报认定管理"
                }
            },
            {
                path: "research/list", //科研任务布局方案
                component: () => import("../views/research/list.vue"),
                meta: {
                    title: "布局方案填报"
                }
            },
            {
                path: "task/list", //任务签订
                component: () => import("../views/task/list.vue"),
                meta: {
                    title: "任务签订填报"
                }
            },
            {
                path: "annual/list", //年度总结
                component: () => import("../views/annual/list.vue"),
                meta: {
                    title: "年度总结填报"
                }
            },
            {
                path: "information/list",
                name: "information-index",
                component: () => import("../views/information/index.vue"),
                meta: {
                    title: "信息报送"
                }
            },
            {
                path: "information/edit", //信息报送
                name: "information-edit",
                component: () => import("../views/information/information-edit.vue"),
                meta: {
                    title: "信息报送"
                }
            },
            {
                path: "information/look", //信息报送
                name: "information-look",
                component: () => import("../views/information/information-look.vue"),
                meta: {
                    title: "信息报送"
                }
            },
            {
                path: "user", //用户信息
                name: "user",
                component: () => import("../views/user/index.vue"),
                meta: {
                    title: "个人信息"
                }
            },
            {
                path: "annual-report",
                name: "annual-report",
                component: () => import("../views/annual-report/index.vue"),
                meta: {
                    title: "实验室年报填报"
                }
            },
            {
                path: "annual-report/form",
                name: "annual-report-form",
                component: () => import("../views/annual-report/form.vue"),
                meta: {
                    title: "实验室年报填报表单"
                }
            },
            {
                path: "voucher-apply",
                name: "voucher-apply",
                component: () => import("../views/voucher-apply/index.vue"),
                meta: {
                    title: "申请列表"
                }
            },
            {
                path: "voucher-apply/commitment",
                name: "voucher-apply-commitment",
                component: () => import("../views/voucher-apply/commitment.vue"),
                meta: {
                    title: "创新券申领承诺书"
                }
            },
            {
                path: "voucher-apply/form",
                name: "voucher-apply-form",
                component: () => import("../views/voucher-apply/form.vue"),
                meta: {
                    title: "申领创新券"
                }
            },
            {
                path: "basic-info",
                name: "basic-info",
                component: () => import("../views/basic-info/index.vue"),
                meta: {
                    title: "基本信息"
                }
            }
        ]
    }
];

const router = new VueRouter({
    mode: "history",
    base: "/cxqPersonClient",
    routes
});

router.beforeEach(async (to, from, next) => {
    console.log("路由守卫 - 从:", from.name, from.path, "到:", to.name, to.path);
    console.log("路由守卫 - 目标路由:", to.name, "查询参数:", to.query);

    if (to.meta.title) {
        document.title = to.meta.title;
    }

    // 先检查是否有 personToken 和 personUserInfo，如果有则自动登录并跳转到首页
    let token = store.getters.token;
    if (!token) {
        const personToken = sessionStorage.getItem("personToken");
        const personUserInfo = sessionStorage.getItem("personUserInfo");
        
        if (personToken && personUserInfo) {
            console.log("路由守卫 - 检测到 personToken 和 personUserInfo，自动登录");
            try {
                // 同步设置 token 到 store
                const personUserInfoObj = JSON.parse(personUserInfo);
                store.commit("user/SET_TOKEN", personToken);
                store.commit("user/SET_NAME", personUserInfoObj.name || "");
                if (personUserInfoObj.phone) {
                    store.commit("user/SET_USER_PHONE", personUserInfoObj.phone);
                }
                // 同时设置到 localStorage
                setToken(personToken);
                if (personUserInfoObj.name) {
                    setName(personUserInfoObj.name);
                }
                if (personUserInfoObj.phone) {
                    setUserPhone(personUserInfoObj.phone);
                }
                token = personToken;
                console.log("路由守卫 - 自动登录成功，token已设置");
                
                // 如果访问的是登录页或根路径，直接跳转到首页
                if (to.name === "login" || to.path === "/") {
                    console.log("路由守卫 - 已登录，从登录页跳转到首页");
                    next({ path: "/index", replace: true });
                    return;
                }
            } catch (error) {
                console.error("路由守卫 - 自动登录失败:", error);
                // 如果自动登录失败，清除认证信息
                sessionStorage.removeItem("personToken");
                sessionStorage.removeItem("personUserInfo");
            }
        }
    }

    // 如果是登录相关页面
    if (to.name === "login" || to.name === "login-register" || to.name === "stop") {
        // 如果已经有 token，直接跳转到首页（避免已登录用户看到登录页）
        if (token) {
            console.log("路由守卫 - 登录页但已有token，跳转到首页");
            next({ path: "/index", replace: true });
            return;
        }
        console.log("路由守卫 - 登录相关页面，直接放行");
        next();
        return;
    }

    // 如果是统一认证回调页面
    if (to.name === "auth-login") {
        console.log("路由守卫 - 统一认证回调页面");

        // 检查是否已经有token（可能已经通过上面的自动登录设置了）
        if (token) {
            console.log("路由守卫 - 已有token，直接跳转到首页");
            next({ path: "/index", replace: true });
            return;
        }

        // 如果有code参数，说明是从统一认证跳转回来的
        if (to.query.code) {
            console.log("路由守卫 - 有code参数，允许访问");
            // 设置会话标记，表示正在进行认证
            sessionStorage.setItem("authInProgress", "true");
            sessionStorage.setItem("authCode", to.query.code);
            next();
        } else if (sessionStorage.getItem("client-userInfo") != null && sessionStorage.getItem("client-userInfo") != "undefined" && sessionStorage.getItem("client-userInfo") != undefined) {
            console.log("路由守卫 - 有client-userInfo参数，允许访问");
            next();
        } else {
            console.log("路由守卫 - 没有code参数");

            // 检查是否有 personToken 和 personUserInfo，如果有就直接跳转到首页
            const personToken = sessionStorage.getItem("personToken");
            const personUserInfo = sessionStorage.getItem("personUserInfo");
            if (personToken && personUserInfo) {
                console.log("路由守卫 - 检测到 personToken 和 personUserInfo，直接跳转到首页");
                next({ path: "/index", replace: true });
                return;
            }

            // 检查是否有会话中的认证标记和code
            const authInProgress = sessionStorage.getItem("authInProgress");
            const authCode = sessionStorage.getItem("authCode");

            if (authInProgress === "true" && authCode) {
                console.log("路由守卫 - 检测到认证正在进行中，使用会话中的code");
                // 重定向到带有code的URL
                next({ path: "/auth-login", query: { code: authCode, state: "cxqPersonClient" } });
                return;
            }

            // 检查是否有会话中的认证标记和client-userInfo
            if (sessionStorage.getItem("client-userInfo")) {
                console.log("路由守卫 - 检测到认证正在进行中，使用会话中的client-userInfo");
                next({ path: "/auth-login" });
                return;
            }

            console.log("路由守卫 - 重定向到登录页");
            // 清除可能的残留标记
            sessionStorage.removeItem("authInProgress");
            sessionStorage.removeItem("authCode");
            // 如果没有code，重定向到登录页
            next({ path: "/", replace: true });
        }
        return;
    }

    // 检查是否有token（可能已经通过上面的自动登录设置了）
    console.log("路由守卫 - 当前token:", token);

    if (!token) {
        console.log("路由守卫 - 没有token，重定向到登录页");
        next("/");
        return;
    }

    // 如果已经有 token，检查 sessionStorage 中是否还有 personToken 和 personUserInfo
    // 如果被清除了，说明用户可能手动清除了 sessionStorage，需要重新登录
    if (token) {
        const personToken = sessionStorage.getItem("personToken");
        const personUserInfo = sessionStorage.getItem("personUserInfo");
        
        // 如果 token 存在但 personToken 或 personUserInfo 不存在，说明 sessionStorage 被清除了
        if (!personToken || !personUserInfo) {
            console.log("路由守卫 - 检测到 sessionStorage 中的认证信息被清除，需要重新登录");
            // 清除 token 和用户信息
            store.dispatch("user/resetToken").then(() => {
                // 跳转到登录页
                next({ path: "/", replace: true });
            });
            return;
        }
    }

    console.log("路由守卫 - 有token，允许访问");
    next();
});

export default router;
